import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { Payment } from '@vsolv/packages/payments/domain';
import { BANK_ACCOUNT_SVG, PAYMENT_METHOD_ICONS } from '../payment-method-icons';

@Component({
  selector: 'vs-payment-method-item',
  templateUrl: './payment-method-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PaymentMethodItemComponent {
  @HostBinding('class') protected _classes = 'block';

  @Input() paymentMethod?: Payment.PaymentMethod | null;

  @Input() minify = false;

  get paymentMethodSvg() {
    return this.paymentMethod?.creditCard
      ? (PAYMENT_METHOD_ICONS[this.paymentMethod.creditCard.cardType] ?? null)
      : this.paymentMethod?.bankAccount
        ? BANK_ACCOUNT_SVG
        : null;
  }
}
